import { baseApi } from '@/shared/api'
import type {
  ClientCard,
  ClientDebts,
  ClientDebtsQuery,
  ClientList,
  ClientStats,
  ClientStatsQuery,
  ClientsQuery,
} from '../model/types'

export const clientApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /**
     * Клиенты, закреплённые за менеджером в 1С. Поиск, фильтры, сортировка, страница и итоги
     * `summary` — на сервере, по всей выборке (правило 11). Параметры уходят как есть: их
     * имена и значения — имена ручки (`docs/roles/03-frontend-architecture.md` §8).
     */
    getClients: build.query<ClientList, ClientsQuery>({
      query: (params) => ({ url: '/clients', params }),
      providesTags: (res) => [
        { type: 'Client', id: 'LIST' },
        ...(res?.items ?? []).map((item) => ({ type: 'Client' as const, id: item.code })),
      ],
    }),

    /**
     * Статистика за период: итоги по всем клиентам в `summary.totals`, разрез по месяцам или по
     * клиентам в строках. Период по умолчанию — текущий месяц, его выбирает бэк (`summary.from/to`).
     */
    getClientStats: build.query<ClientStats, ClientStatsQuery>({
      query: (params) => ({ url: '/clients/stats', params }),
      providesTags: [{ type: 'Client', id: 'STATS' }],
    }),

    /** Долги: клиенты с положительным остатком. Сортировка и итоги — на сервере. */
    getClientDebts: build.query<ClientDebts, ClientDebtsQuery>({
      query: (params) => ({ url: '/clients/debts', params }),
      providesTags: [{ type: 'Client', id: 'DEBTS' }],
    }),

    /** Карточка клиента. Чужой и несуществующий — одинаково `404`. */
    getClient: build.query<ClientCard, string>({
      query: (code) => ({ url: `/clients/${encodeURIComponent(code)}` }),
      providesTags: (_res, _err, code) => [{ type: 'Client', id: code }],
    }),
  }),
})

export const {
  useGetClientsQuery,
  useGetClientQuery,
  useGetClientStatsQuery,
  useGetClientDebtsQuery,
} = clientApi
